/* eslint-disable consistent-return */
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import useAxios from './useAxios';
import { useAuth } from './useAuth';

const RoleContext = createContext({} as any);

export const useRoleContext = () => useContext(RoleContext);

export const RoleProvider = ({ children }: any) => {
  const { post } = useAxios();
  const [role, setRole] = useState<any>(null);
  const [userId, setUserId] = useState<any>(null);
  const [aiPrivileges, setAIPrivileges] = useState<any>(null);
  const [reviewerLabel, setReviewerLabel] = useState<any>(null);
  const [isRoleFetching, setRoleFetching] = useState(false);
  const [isRoleFetched, setRoleFetched] = useState(false);

  const { logout } = useAuth();

  // Fetch user role from the API
  useEffect(() => {
    if (!role) {
      setRoleFetching(true);
      const fetchUserRole = async () => {
        try {
          const data: any = await post('user-manager/get_user_info_by_token', {}).then((response: any) => {
            const { status } = response;
            
            if ([200, 201].includes(status) && response.data.messages[0]) {
              setRoleFetched(true);
              return response.data.messages[0];
            } else if ([200, 201].includes(status) && response.data.errors[0]) {
              return {
                error: response.data.errors[0]
              };
            }
          });

          if (data && data.role && data.user_id) {
            setRole(data.role);
            setUserId(data.user_id);
            if (data.ai_privileges) setAIPrivileges(data.ai_privileges);
            if (data.reviewer_label) setReviewerLabel(data.reviewer_label);
          } else {
            console.error('Error fetching user role:', data);
            setRole(null);
            setRoleFetching(false);
            setAIPrivileges(null);
            setReviewerLabel(null);

            logout();
          }
          setRoleFetching(false);
        } catch (error) {
          console.error('Error fetching user role:', error);
          setRole(null);
          setRoleFetching(false);
          setAIPrivileges(null);
        }
      };

      fetchUserRole();
    } else {
      setRoleFetching(false);
    }
  }, [role]);

  // Memoize the context value to avoid unnecessary re-renders
  const contextValue = useMemo(() => ({ role, userId, aiPrivileges, reviewerLabel, isRoleFetching, isRoleFetched }), [role]);

  return (
    <RoleContext.Provider value={contextValue}>
      {children}
    </RoleContext.Provider>
  );
};
